var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 907,
    height: 770,
    viewBox: "0 0 907 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.85 1055.89C1188.34 1149.79 1094.18 1237.69 994.361 1286.22C894.824 1334.62 805.859 1293.49 705.927 1325.7C600.395 1359.71 483.029 1499.32 393.536 1479.85C300.458 1459.59 344.357 1290.51 277.783 1232.54C216.867 1179.5 80.2016 1229.86 31.4909 1164.57C-15.8019 1101.19 -0.611622 990.393 23.0001 891.04C45.6291 795.821 111.882 702.372 163.7 608.265C209.181 525.668 274.6 450.437 311.877 366.409C362.963 251.254 331.849 120.267 423.422 22.8113C507.71 -66.8911 629.878 -61.3587 731.371 -80.0299C821.087 -96.5346 893.606 -56.8161 984.492 -80.4064C1095.55 -109.233 1216.78 -242.24 1316.55 -231.917C1409.45 -222.305 1438.65 -115.631 1466.51 -30.534C1492.45 48.7006 1468.69 151.293 1471.88 242.531C1474.74 324.48 1496.22 397.742 1484.54 484.547C1472.52 573.788 1438.53 665.663 1402.52 757.648C1362.98 858.637 1331.92 963.857 1260.85 1055.89Z",
    fill: "url(#paint0_linear_4972_839)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1316.96 1005.96C1245.98 1098.22 1153.48 1184.33 1055 1231.43C956.803 1278.39 868.234 1236.84 769.487 1267.77C665.208 1300.44 550.2 1437.52 461.312 1417.4C368.863 1396.47 410.775 1229.53 344.239 1171.51C283.359 1118.43 148.375 1166.99 99.4764 1101.9C52.0008 1038.71 66.0084 929.187 88.4713 831.066C109.999 737.029 174.783 645.156 225.254 552.495C269.551 471.168 333.681 397.32 369.834 314.498C419.379 200.997 387.299 71.0453 477.142 -24.5533C559.838 -112.547 680.98 -105.914 781.401 -123.435C870.17 -138.923 942.424 -98.9213 1032.29 -121.412C1142.09 -148.894 1260.99 -279.403 1359.98 -268.241C1452.16 -257.847 1482.11 -151.979 1510.53 -67.483C1536.99 11.1922 1514.4 112.517 1518.43 202.859C1522.05 284.003 1544.03 356.724 1533.27 442.536C1522.2 530.758 1489.38 621.377 1454.56 712.087C1416.32 811.677 1386.53 915.534 1316.96 1005.96Z",
    fill: "url(#paint1_linear_4972_839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4972_839",
    x1: 854.329,
    y1: 783.206,
    x2: 203.668,
    y2: 245.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6A29",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883D17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4972_839",
    x1: 444.846,
    y1: 333.976,
    x2: 1367.18,
    y2: 1446.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008894",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002A2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgVector);
export default __webpack_public_path__ + "static/media/bgVector.06640cd970676284c11a160ca17ec176.svg";
export { ForwardRef as ReactComponent };